import type { FC, SVGProps } from "react";

export const TextItalicIcon: FC<SVGProps<SVGSVGElement>> = (props) => (
  <svg viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <g transform="translate(4.375 3.75)">
      <path
        d="M11.25 0.625C11.25 0.79076 11.1842 0.949731 11.0669 1.06694C10.9497 1.18415 10.7908 1.25 10.625 1.25H7.95078L4.61719 11.25H6.875C7.04076 11.25 7.19973 11.3158 7.31694 11.4331C7.43415 11.5503 7.5 11.7092 7.5 11.875C7.5 12.0408 7.43415 12.1997 7.31694 12.3169C7.19973 12.4342 7.04076 12.5 6.875 12.5H0.625C0.45924 12.5 0.300269 12.4342 0.183058 12.3169C0.0658481 12.1997 0 12.0408 0 11.875C0 11.7092 0.0658481 11.5503 0.183058 11.4331C0.300269 11.3158 0.45924 11.25 0.625 11.25H3.29922L6.63281 1.25H4.375C4.20924 1.25 4.05027 1.18415 3.93306 1.06694C3.81585 0.949731 3.75 0.79076 3.75 0.625C3.75 0.45924 3.81585 0.300269 3.93306 0.183058C4.05027 0.0658481 4.20924 0 4.375 0H10.625C10.7908 0 10.9497 0.0658481 11.0669 0.183058C11.1842 0.300269 11.25 0.45924 11.25 0.625Z"
        fill="currentColor"
      />
    </g>
  </svg>
);
